<template>
  <div :class="mainWrapperClass">
    <div :class="$modal.modalContent">
      <v-flex>
        <p :class="$modal.modalText">
          Enter in your email to receive a password reset link:
        </p>
      </v-flex>
      <v-flex :class="[$modal.modalInput, $modal.shortInput]">
        <InputField :class="{[$modal.errorField] : $v.email.$error }"
                    v-model="$v.email.$model"
                    label="Email*"
                    type="email"
                    @input="onChange"/>
        <p v-if="!$v.email.required && $v.email.$error"
           :class="$modal.errorMessage">
          Email is required
        </p>
        <p v-if="!$v.email.email"
           :class="$modal.errorMessage">
          Email is invalid
        </p>
        <p v-if="errors"
           :class="$modal.errorMessage">
          {{ errors }}
        </p>
      </v-flex>
      <MobileButton v-if="isMobilePlatform"
                    :class="$modal.mobileBtn"
                    :disabled="pending"
                    @click="formAction">
        Submit
      </MobileButton>
      <v-flex v-else
              :class="$modal.modalButtons">
        <BaseButton :button-style="'Main'"
                    :class="$modal.submitBtn"
                    @click="formAction">Submit</BaseButton>
        <button :class="$modal.cancelBtn"
                @click="close()">Cancel</button>
      </v-flex>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Action, Getter } from 'vuex-class';
import { required, email } from 'vuelidate/lib/validators';
import { AUTH_FORGOT_PASSWORD } from '@/apps/auth/store/types';
import authMixins from '@/apps/auth/mixins';
import BaseButton from '@/components/BaseButton';
import InputField from '@/components/InputField';
import MobileButton from '@/apps/mobile/components/MobileButton';

  /**
   * Form to check if phone number exists. On success will store pone data in
   * vuex store for further use.
   */
  @Component({
    name:       'ForgotPassword',
    components: {
      BaseButton,
      InputField,
      MobileButton,
    },
    validations: {
      email: { required, email },
    },
    mixins: [
      authMixins.AuthorizationMixin,
    ],
  })
export default class ForgotPassword extends Vue {
    @Getter isMobilePlatform;
    @Getter pending;

    @Action(AUTH_FORGOT_PASSWORD) vuexAction;
    email = '';

    get mainWrapperClass() {
      const mobileWrapperClass = this.isMobilePlatform ? this.$modal.modalMobile : '';

      return [ this.$modal.modalContentContainer, mobileWrapperClass ];
    }

    /**
     * Pass email in api call.
     * @returns {{email: string}}
     */
    getData() {
      return {
        email: this.email,
      };
    }

    /**
     * Emits `linkSent` event on successful action finish. `linkSent` open
     * small modal with info that email was sent. `linkSent` event
     * should be handled on the parent component to close current modal.
     * @param data
     */
    handleSuccess(data) {
      this.responseData = data;
      this.$emit('link-sent');
    }

    /**
     * Clears the errors if input value is changed.
     */
    onChange() {
      this.errors = null;
    }
  }
</script>


<style src="@/style/modals.scss" lang="scss" module="$modal"></style>



// WEBPACK FOOTER //
// src/apps/auth/components/ForgotPassword.vue